// extracted by mini-css-extract-plugin
module.exports = {"button":"buttonNavigation_button__J7Hg1","arrow":"buttonNavigation_arrow__3EAjk"};
    if(module.hot) {
      // 1790670317306
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  